module.exports = new __parcel__URL__("plasma_cannon_level_3_skin.b490d7d2.png").toString();